import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Select, MenuItem, FormControl, ListItemIcon, ListItemText } from '@mui/material';
// Import flag icons
import EnglishFlag from '../assets/flags/en.svg';
import FrenchFlag from '../assets/flags/fr.svg';
import UserService from '../services/user.service';
import useApi from '../hooks/useApi';
import useAuth from "../hooks/useAuth";

const LanguageSwitcher = ({ compact = false }) => {
  const { i18n, t } = useTranslation();
  const api = useApi();
  const { auth } = useAuth();
  const changeLanguage = async (event) => {
    const language = event.target.value;
    i18n.changeLanguage(language);
    if (auth?.user?.id) {
      try {
        await UserService.update(auth.user.id, { language }, api);
        console.log('Langue mise à jour côté serveur:', language);
      } catch (error) {
        console.error('Erreur lors de la mise à jour de la langue:', error);
      }
    }
  };

  // Determine which flag to show in the button based on the current language
  const currentFlag = i18n.language === 'fr' || i18n.language === 'fr-FR' ? FrenchFlag : EnglishFlag;

  return (
    <Box
      className={compact ? 'language-switcher language-switcher--compact' : 'language-switcher'}
      sx={{
        minWidth: compact ? { xs: 104, sm: 120 } : 120,
        flexShrink: 0,
        ...(compact && {
          '@media (max-width: 374px)': {
            minWidth: 58,
          },
        }),
      }}
    >
      <FormControl fullWidth size="small">
        <Select
          value={i18n.language}
          onChange={changeLanguage}
          displayEmpty
          variant="outlined"
          renderValue={() => (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: compact ? 0.75 : 1 }}>
              <img src={currentFlag} alt="Flag" style={{ width: 24, height: 16 }} />
              <span className="language-label">{i18n.language === 'fr' || i18n.language === 'fr-FR' ? t('french') : t('english')}</span>
            </Box>
          )}
          sx={{ 
            fontSize: compact ? '0.8125rem' : '0.875rem',
            '& .MuiSelect-select': {
              py: compact ? 0.55 : 0.7,
              pl: compact ? 1 : undefined,
              pr: compact ? '26px !important' : undefined,
              display: 'flex',
              alignItems: 'center'
            },
            '& .MuiSelect-icon': compact ? { right: 2 } : undefined,
            ...(compact && {
              '@media (max-width: 374px)': {
                '& .language-label': { display: 'none' },
                '& .MuiSelect-select': { pr: '22px !important' },
              },
            }),
          }}
        >
          <MenuItem value="en">
            <ListItemIcon>
              <img src={EnglishFlag} alt="English Flag" style={{ width: 24, height: 16 }} />
            </ListItemIcon>
            <ListItemText>{t('english')}</ListItemText>
          </MenuItem>
          <MenuItem value="fr">
            <ListItemIcon>
              <img src={FrenchFlag} alt="French Flag" style={{ width: 24, height: 16 }} />
            </ListItemIcon>
            <ListItemText>{t('french')}</ListItemText>
          </MenuItem>
        </Select>
      </FormControl>
    </Box>
  );
};

export default LanguageSwitcher;
